import React from "react";
import { EmployeesVehicleGrid } from "./employeesVehicleGrid";
import { MainLayout } from "../../layout/mainLayout";
import { LoadingIndicator } from "../../framework/loadingIndicatorNew";
import {
    useWorkTimeReportData,
    WorkTimeReportData,
} from "../../../hooks/reporting/useWorkTimeReportData";
import { WorkTimeReportFilters } from "../WorkTimeReportFilters";

const dataInitialized = (data: WorkTimeReportData) =>
    !!data.workTimeReportData &&
    !!data.salaryRowTypes &&
    !!data.workTimeTypes &&
    !!data.vehicles &&
    !!data.costCenters &&
    !!data.customers &&
    !!data.employees &&
    !!data.employeeGroups;

export const EmployeesMain = () => {
    const data = useWorkTimeReportData();
    const initialized = dataInitialized(data);

    return (
        <MainLayout
            noContainer
            className="fluid"
            topComponent={
                initialized ? (
                    <WorkTimeReportFilters
                        vehicles={data.vehicles}
                        costCenters={data.costCenters}
                        employees={data.employees}
                        employeeGroups={data.employeeGroups}
                        workTimeTypes={data.workTimeTypes}
                        customers={data.customers}
                    />
                ) : null
            }
            noTopContainer
        >
            <>
                <LoadingIndicator loading={data.loading || !initialized} />
                {initialized && <EmployeesVehicleGrid {...data} />}
            </>
        </MainLayout>
    );
};
